import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Lookup } from 'src/common/Common.Type'
import { ParentHospitalConfigurations, RepeatedDoses, userDose } from 'src/common/constants'
import AccordionCard from 'src/component/Accordion/Component'
import Title from 'src/component/Accordion/Component/Title'
import CheckBox from 'src/component/CheckBox'
import CostTag from 'src/component/CostTag'
import DropDown from 'src/component/DropDown'
import Field from 'src/component/field'
import { useCalcAltCost } from 'src/hooks/CommonUse/useCalcAltCost'
import { useGet } from 'src/hooks/useGet'
import { GetDoseInfoForMedicines } from 'src/requests/Shared'

const MedicineCard = ({
    isManual = false,
    item,
    index,
    medicineLookup,
    recordID,
    medicineList,
    setMedicineList,
    hospitalId,
    ApproveDoctorRequest,
    isCustomAmount = false,
    hasEssentialCheckbox = false,
    decisionId,
    coveredMonths = 1
}: any) => {

    const [isOpened, setIsOpened] = useState(!item.amount)
    const [itemData, setItemsData] = useState({
        altMedicine: null,
        reqMedId: item.requestMedicineId,
        doseAmount: "",
        doseRepeat: "",
        userDoseRepeate: null,
        isSelected: false,
        directAmount: "",
        isModel56: false,
        duration: "",
        durationType: null,
        isEssential: false,
        allowAllDuration: false,
        decisionId: decisionId,
        fromDonationsStock: false,
        isCustomAmount: false

    })

    const { t } = useTranslation()
    const [openAlt, toggleOpenAlt] = useState(!item.amount)

    const { data: medicineResult } = useCalcAltCost(itemData, hospitalId)
    const { data: MedicineInfo } = useGet({ API: GetDoseInfoForMedicines, isNotValid: !item.decisionMedicineId || !isOpened, depArr: [item.decisionMedicineId, !isOpened], params: [item.decisionMedicineId], defaultValue: [] })
    //@ts-ignore
    const isNotAvalilable = useMemo(() => medicineResult?.availableStock == 0, [itemData?.medicineResult])

    //TODO:REFACTOR
    const isPhrmHasIsEssentia =
        JSON.parse(sessionStorage.getItem("hospitalCofigurations") || "[]")
            ?.some((item: any) => item?.feature === ParentHospitalConfigurations.PossibilityMakingAltMedicineEssential && !!item?.isAllowed) || false

    const isAllowToDispenseMedicinesForMoreThanOneMonth =
        JSON.parse(sessionStorage.getItem("hospitalCofigurations") || "[]")
            ?.some((item: any) => item?.feature === ParentHospitalConfigurations.AllowToDispenseMedicinesForMoreThanOneMonthInOneRequest && !!item?.isAllowed) || false

    useEffect(() => {
        handleChange("reqMedId", item?.requestMedicineId)

    }, [item.requestMedicineId])

    const handleChange = (key: string, value: string | number | boolean | Lookup | Lookup[] | null) => {
        let tempArr = medicineList
        let temObj = tempArr.find((ele: any) => ele.reqMedId == item?.requestMedicineId) || {}
        let keyIndex = tempArr.map((ele: any) => ele.reqMedId).indexOf(item?.requestMedicineId) >= 0 ?
            tempArr.map((ele: any) => ele.reqMedId).indexOf(item?.requestMedicineId) : medicineList.length

        temObj[key] = value

        tempArr[keyIndex] = temObj

        setMedicineList((prev: any[]) => ([...tempArr]))

        setItemsData((prev: any) => ({ ...prev, [key]: value }))
    }

    const handleActiveDuration = (sOption: any) => {
        handleChange("duration", sOption.repeat)
        handleChange("durationType", sOption)
        handleChange("allowAllDuration", sOption.allowAllDuration)
    }

    const handleActive = (value: boolean) => {
        handleChange("reqMedId", item?.requestMedicineId)
        handleChange("isAvailable", item?.isAvailable)
        handleChange("isApproved", item?.isApproved)

        !value && handleChange("fromDonationsStock", !item?.availableStock)

        handleChange("isSelected", value)
        handleChange("isDefault", true)

        value && handleChange("isModel56", false)

        setIsOpened(!value)

        if (value) handleChange('cost', (item?.price * item?.amount)?.toFixed(2))

        handleChange("medicineName", item.medicineName)
        handleChange("amount", item.amount)
        handleChange("price", (item.price * item.amount)?.toFixed(2))
        handleChange("unitPrice", item.price?.toFixed(2))
        handleChange("medicineResult", medicineResult)
    }

    useEffect(() => {
        if (medicineResult?.amount) {
            handleChange("altPrice", (medicineResult?.medicinePrice * medicineResult?.amount)?.toFixed(2))
            handleChange("medicineAltPrice", (medicineResult?.medicinePrice))
        } else {
            handleChange("altPrice", 0)
        }
    }, [medicineResult])

    const handlModel = (value: boolean) => {
        handleChange("isModel56", value)
        value && handleChange("isSelected", false)
    }
    useEffect(() => {
        //@ts-ignore
        handleChange("doseAmount", MedicineInfo.dosePerDay)
        //@ts-ignore
        handleChange("doseRepeat", MedicineInfo.doseCountPerTime)
        //@ts-ignore
        handleChange("userDoseRepeate", userDose.find(item => item.value == MedicineInfo.doseTypeId) || null)
        //@ts-ignore
        handleChange("directAmount", MedicineInfo.directAmount)
        //@ts-ignore
        handleChange("duration", 1)
        //@ts-ignore
        handleChange("durationType", RepeatedDoses.find(item => item.value == 30))

    }, [MedicineInfo])

    useEffect(() => {
        //@ts-ignore
        if (itemData?.altMedicine?.allowDirectAmount)
            //@ts-ignore
            handleChange("directAmount", MedicineInfo.directAmount)

    }, [itemData?.altMedicine])


    useEffect(() => {
        const sMedicine = medicineLookup.find((med: Lookup) => med.value == item?.medicineId)
        handleChange("altMedicine", sMedicine)
        handleChange("isDefault", true)
    }, [item, medicineLookup])


    const handleSelectedMed = (sOption: Lookup) => {
        handleChange("altMedicine", sOption)
        handleChange("isDefault", false)
    }

    useEffect(() => {
        handleChange("isDefault", !openAlt)

    }, [openAlt])


    const repeatedDosesOptions = useMemo(() => {
        const hasAllDuration = RepeatedDoses.some(d => d.value === 4)

        if (itemData.isEssential && !hasAllDuration && hasEssentialCheckbox && isPhrmHasIsEssentia) {
            return [
                ...RepeatedDoses,
                { label: "all-duration", value: 4, repeat: 4, isAll: true, allowAllDuration: true }
            ]
        }

        if (!itemData.isEssential && hasAllDuration) {
            return RepeatedDoses.filter(d => d.value !== 4)
        }

        return RepeatedDoses
    }, [itemData.isEssential, isPhrmHasIsEssentia])

    return (
        <AccordionCard
            contentTitle={
                <Title
                    isReplaced={item?.isRequiredChange}
                    toggleOpenAlt={toggleOpenAlt}
                    tabIndex={index}
                    handleActive={handleActive}
                    value={itemData["isSelected"]}
                    item={item}
                    handleDonatedStock={
                        item?.availableDonatedStock > 0 &&
                        ((value: boolean) => handleChange("fromDonationsStock", value))
                    }
                    donatedStockValue={itemData["fromDonationsStock"]}
                >
                    {
                        ApproveDoctorRequest ?
                            <div className='row'>
                                < div className='col-sm-4 modal-label' >
                                    <CheckBox className="" setValue={(value: boolean) => handlModel(value)} value={itemData["isModel56"]} label={'model65'} />
                                </div >
                            </div >
                            : ""
                    }

                </Title >
            }

            isShow={!isManual ? isOpened : (openAlt && !itemData["isSelected"] || (openAlt && item.amount && !itemData["isSelected"]))} >


            <div className={`row row-section${isNotAvalilable ? 'no-available' : ""}`}>

                {isAllowToDispenseMedicinesForMoreThanOneMonth && coveredMonths > 1 && !isCustomAmount &&
                    <p className='text-center text-danger fw-bold'>{t("pleaseInsetOneMonthDose")}</p>
                }
                <div className='col-md-11'>
                    <div className='row'>
                        {medicineResult?.amount ? <CostTag amount={medicineResult?.amount} title={"total-amount"} /> : ""}
                        {medicineResult?.medicinePrice ?
                            <CostTag amount={medicineResult?.medicinePrice * medicineResult?.amount} title={"total-cost"} /> : ""
                        }
                    </div>
                </div>

                <DropDown placeholder={'alt-medicine'} className='col-md-6 col-sm-12' label={'alt-medicine'} options={medicineLookup} setVal={(sOption: Lookup) => handleSelectedMed(sOption)} val={itemData["altMedicine"]} />
                <Field className='col-md-6 col-sm-12' label='doseAmount' setValue={value => handleChange('doseAmount', value)} value={itemData["doseAmount"]} />
                <Field className='col-md-6 col-sm-12' label='doseRequest' setValue={value => handleChange('doseRepeat', value)} value={itemData["doseRepeat"]} />
                <DropDown placeholder={'user-dose-repeat'} className='col-md-6 col-sm-12' label={'user-dose-repeat'} options={userDose} setVal={(sOption: Lookup) => handleChange('userDoseRepeate', sOption)} val={itemData["userDoseRepeate"]} />

                {//@ts-ignore
                    itemData?.altMedicine?.allowDirectAmount &&
                    <Field className='col-md-6 col-sm-12' label='directionAmount' setValue={value => handleChange('directAmount', value)} value={itemData["directAmount"]} />
                }
                {/* @ts-ignore */}
                {!!itemData.durationType?.allowAllDuration && !!itemData.isEssential ||
                    <Field className='col-md-6 col-sm-12' label='duration' setValue={value => handleChange('duration', value)} value={itemData["duration"]} />
                }

                {
                    item?.availableDonatedStock > 0 &&
                    <div className='col-md-6 col-sm-12 mt-2 d-flex flex-column justify-content-center'>
                        <CheckBox
                            className="flex-row-reverse justify-content-end align-items-center"
                            setValue={(value: boolean) => handleChange("fromDonationsStock", value)}
                            value={itemData["fromDonationsStock"]}
                            label={'applyFromDonatedStock'}
                            disabled={
                                isNaN(Number(itemData.directAmount)) ||
                                Number(itemData.directAmount) <= 0 ||
                                Number(itemData.directAmount) >= Number(item?.availableDonatedStock ?? 0)
                            }
                        />
                        <span className='text-muted mt-1' style={{ fontSize: '12px' }}>
                            {t('availableDonatedStockCount', {
                                count: item?.availableDonatedStock ?? 0,
                            })}
                        </span>
                    </div>
                }
                {hasEssentialCheckbox && isPhrmHasIsEssentia &&
                    <div className='col-md-6 col-sm-12 mt-2 d-flex flex-column justify-content-center'>
                        <CheckBox
                            value={itemData["isEssential"]}
                            setValue={(value: boolean) => handleChange('isEssential', value)}
                            label='isEssentialToSelect'
                            className='flex-row-reverse  justify-content-end align-items-center'
                            disabled={itemData.isCustomAmount}
                        />
                        <span className='text-muted mt-1' style={{ fontSize: '12px' }}>
                            ({t('isEssentialDescription')})
                        </span>
                    </div>
                }
                {isCustomAmount && coveredMonths > 1 &&
                    <div className='col-md-6 col-sm-12 mt-2 d-flex flex-column justify-content-center'>
                        <CheckBox
                            value={itemData["isCustomAmount"]}
                            setValue={(value: boolean) => handleChange('isCustomAmount', value)}
                            label='quantityCoversAllCoveredMonths'
                            className='flex-row-reverse justify-content-end align-items-center'
                            disabled={itemData.isEssential}
                        />
                    </div>
                }
                <div className='col-md-6 col-sm-12 repeating-section'>
                    {repeatedDosesOptions.map((item: any, index: number) => (
                        //@ts-ignore
                        <div className={`pointer ${itemData["durationType"]?.value == item.value ? 'selected' : ""}`} onClick={() => handleActiveDuration(item)} key={item.value}>{t(item.label)}</div>
                    ))}
                </div>
            </div>
        </AccordionCard >
    )
}

export default MedicineCard